<template>
    <ModalComponent
        :name="'comunicado-' + comunicado.id"
        :title="'Enviar Comunicado: ' + (comunicado.titulo ?? comunicado.whatsappTemplate?.name)"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <template v-if="comunicado.tipo === 1">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="email">Enviar a:</label>
                            <ValidationProvider name="objetivo" rules="required" v-slot="{ errors }">
                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="objetivo" v-model="enviar_a">
                                    <option value="1" selected>Todos los abonados</option>
                                    <option value="2">Todos los compradores de un evento</option>
                                    <option value="3">Una lista personalizada</option>
                                    <option value="4">Todos los emails recopilados de recordatorios</option>
                                </select>
                                <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <template v-if="enviar_a == 2">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="provincias">Seleccionar evento</label>
                                <ValidationProvider name="evento" rules="required" v-slot="{ errors }">
                                    <multiselect
                                        v-model="evento"
                                        :options="events"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder="Select one"
                                        label="name"
                                        track-by="name"
                                    ></multiselect>
                                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                    </template>
    
                    <template v-if="enviar_a == 3">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="provincias">Seleccionar base</label>
                                <ValidationProvider name="base" rules="required" v-slot="{ errors }">
                                    <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="base" v-model="base">
                                        <template v-for="base in bases">
                                            <option :key="base.id" :value="base.id">{{ base.nombre }}</option>
                                        </template>
                                    </select>
                                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                    </template>
                </template>
                <b-col cols="12" class="mb-3" v-else>
                    <h4>El coste total del envío de este comunicado por WhatsApp es de {{ comunicado.coste_envio_whatsapp | formatear_precio }}</h4>
                </b-col>

                <template v-if="listo">
                    <div class="col-12 text-center">
                        <h1 class="font-weight-bold">¿ENVIAR COMUNICADO?</h1>
                    </div>
                    <div class="col-12 text-center">
                        <Button type="submit" name="button">SI, ENVIAR</Button>
                    </div>
                </template>                        
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['comunicado', 'bases', 'events', 'recordatorios'],
    data() {
        return {
            email: null,
            loading: false,
            enviar_a: 1,
            evento: {},
            base: null,
        }
    },
    computed: {
        listo() {
            var listo = false;
            if(this.enviar_a == 1) {
                listo = true;
            }

            if(this.enviar_a == 2 && this.evento) {
                listo = true;
            }

            if(this.enviar_a == 3 && this.base) {
                listo = true;
            }

            if(this.enviar_a == 4 && this.recordatorios) {
                listo = true;
            }

            return listo;
        }
    },
    methods: {
        close(enviado) {
            this.$emit('close', 'comunicado-' + this.comunicado.id, enviado);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.enviar();
            }
        },
        enviar() {
            this.loading = true;

            const params = {
                filters : {},
                comunicado_id: this.comunicado.id,
                enviar_a: this.enviar_a,
                evento: this.evento.id,
                base: this.base,
                recordatorios: this.recordatorios
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.enviar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.close(true);
            }).finally(() => this.loading = false);
        }
    },
    components: {
        ModalComponent
    }
}
</script>
